import { updateFuelingServiceTags } from '../../api/fueling-service.ts';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { UpdateFuelingServiceTagsRequest } from '../../api/requests/fueling-service-request.ts';

export default function useUpdateFuelingServiceTags(): UseMutationResult<
  Awaited<ReturnType<typeof updateFuelingServiceTags>>,
  Error,
  UpdateFuelingServiceTagsRequest
> {
  return useMutation({
    mutationFn: updateFuelingServiceTags,
  });
}
